import React from "react";
import styles from "../components/Sections/TermsAndConditions.module.css";
import Footer from "../components/Layout/Footer";
import Navbar from "../components/Layout/Navbar";

function Privacy() {
  return (
    <div>
      <Navbar />
      <div className={styles.tc}>
        <div className={styles.tc_inner}>
          <h1>Privacy policy</h1>
          <div>
            <h2>PRIVACY STATEMENT</h2>
            <p>
              Thanks for using https://tenonlogistics.com/ this privacy
              statement applies to our website, it does not apply to any sites,
              services and products that do not display or link to this
              statement or that have their own privacy statements.
              <br /> <span>TENON LOGISTICS</span> commits to protect your
              privacy. By using our website, you expressly consent to the
              collection, storage and use of your information as outlined in
              this Privacy Policy and you are deemed to have read and agreed to
              the terms and conditions of this Privacy Policy.
              <br /> Privacy policy
              <br />
              <span>TENON LOGISTICS</span> appreciates the importance of privacy
              of personal information submitted by our Users. Our privacy policy
              does not allow sharing of the information submitted by the
              visitors of our website and users of our website regardless of how
              it is collected or what format it is held in. If all the
              information of our users is shared on our website, we will have to
              obtain a written consent beforehand.
              <br />
              Please read our terms and conditions to ensure you understand how
              your personal information will be treated in our organization.
              These terms and conditions summarize our policy and practices as
              it pertains to the collection, use, transfer, storage and disposal
              of personal information collected through electronic means for the
              use of our website.
              <br />
              Collection of Information
              <br />
              We collect many kinds of information to operate effectively and
              provide you the best products, services and experiences we can. We
              constantly review our systems and data to ensure the best possible
              service to our clients.
              <br />
              We collect information when you register, sign in and use our
              website. Such information may include name, address, email
              address, telephone and fax number. We collect this information in
              various ways, including web forms, technologies like cookies, web
              logging and software on your computer or other device.
              <br />
              The secure server software we use encrypts all information you
              input before it is sent to us. In addition, your account
              information is securely protected for your privacy and security.
              Your information will be treated securely. You may choose not to
              provide the information. If you leave this information for the
              purpose of contacting us or requesting information, we will keep a
              record of that correspondence for internal data collection
              purposes. To help prevent others from viewing your personal
              information, you first will be required to sign in.
              <br />
              Except as described in this privacy statement, we will not
              disclose your personal information to a third party without your
              consent. We use the information we collect to operate, improve and
              personalize the services we offer. We may also use the information
              to communicate with you, for example, informing you about your
              account and security updates and we may use the information to
              help make the ads you see on our website more relevant.
            </p>
          </div>

          <div>
            <div>
              <h2>Non-Identifying Information</h2>
              <ul>
                <p>
                  If you visit our website, we may automatically collect and
                  store the following information:
                </p>
                <li>
                  The name of the domain from which you access the Internet.
                </li>
                <li>
                  The type of browser and operating system used to access our
                  website.
                </li>
                <li>The date and time you accessed our website.</li>
                <li>
                  The Internet address of the website from which you linked
                  directly to our website.
                </li>
                <p>
                  This information is used by the software programs on our
                  website to create summary statistics that allows us to assess
                  the number of visitors, determine technical design
                  specifications, monitor system performance, and help us make
                  our website more useful to clients.
                </p>
                <p>
                  We use non-personally identifiable information to monitor the
                  use and performance of our website so that we can learn more
                  about how to improve our Services and significantly enhance
                  your experience on our website.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <h3>Third Parties</h3>
                <p>
                  Our Services are provided by our website service provider who
                  serves as an independent contractor in providing these web
                  applications to our clients. You can verify our service
                  provider by looking for a “powered by” phrase at the bottom of
                  our webpage. Our contracted service providers will not give
                  away, trade, or sell any information obtained from our Users;
                  and our service providers has agreed to adhere to our privacy
                  policy.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <h3>Email Privacy Policy</h3>
                <p>
                  We have created our email privacy policy to demonstrate our
                  commitment to your privacy and the protection of your
                  information. When you provide your email address to us, you
                  give us authorization to contact or send you certain
                  notification emails.
                </p>
                <p>
                  We use security measures to protect against the loss, misuse
                  and alteration of data used by our system you should however
                  always take steps to protect the confidentiality of your
                  password. It is important for you to protect your password
                  against unauthorized access and be sure to sign off when you
                  finish using a shared computer.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <h3>Communication Preferences</h3>
                <p>
                  You can stop the delivery of promotional e-mail from our
                  website by following the specific instructions in the e-mail
                  you receive. You may also have the option of proactively
                  making choices about the receipt of promotional e-mail,
                  telephone calls, and postal mail.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <h3>Display of Advertising</h3>
                <p>
                  When we display online advertisements to you, we will place
                  one or more cookies in order to recognize your computer when
                  we display an ad to you. Over time, we may gather information
                  from websites where we serve ads and use the information to
                  help provide more relevant ads to you.{" "}
                </p>
              </ul>
            </div>
          </div>

          <div>
            <h2>Confidentiality</h2>
            <ul>
              <p>
                We will divulge any information about you to any third party
                without advance permission or unless ordered by a court of law
                or the appropriate regulatory authorities. We may also release
                information (including your name, addresses, telephone number,
                and account activity) if we believe that such release is
                necessary to:
              </p>
              <li>
                comply with the law, warrants, court orders, government
                investigations, or other legal process.
              </li>
              <li>enforce or apply the terms of any of our user agreement.</li>
              <li>
                investigate or respond to allegations of fraud, intellectual
                property infringement, or other unlawful activity.
              </li>
              <li>protect the rights, property of our users, or others.</li>
              <li>to protect our operations; or</li>
              <li>
                to permit us to pursue available remedies or limit the damages
                that we may sustain.
              </li>
              <p>
                We will take steps that are reasonable in the circumstances to
                maintain administrative, technical and physical safeguards that
                will: (a) protect your confidentiality and the privacy of the
                individuals who are the subjects of that information; and (b)
                protect any reasonably anticipated threat or hazard to the
                security or integrity or unauthorized use, disclosure or
                modification of your information.
              </p>
            </ul>

            <ul>
              <h3>Our Commitment to Data Security</h3>
              <p>
                To prevent unauthorized access, maintain data accuracy, and
                ensure the correct use of information, we have put in place
                appropriate physical, electronic, and managerial procedures to
                safeguard and secure the information we collect online. All
                personal information will be removed and disposed of once it is
                no longer required for its intended use.
              </p>
              <p>
                We work very hard to protect your privacy and use technical and
                organizational security precautions and industry-standard
                precautions to protect your data from manipulation, loss,
                destruction or access by unauthorized persons, but our
                Organization cannot guarantee that unauthorized use will never
                occur (e.g. that someone will not overcome our security
                measures) and makes no representations or warranties to this
                effect. Our security procedures are continuously revised based
                on new technological developments.
              </p>
            </ul>

            <ul>
              <h3>Exclusions and Limitations</h3>
              <p>
                The information on our website is provided to the fullest extent
                permitted by law, but subject to applicable law:
              </p>
              <li>
                excludes all representations and warranties relating to this
                website and its contents or which is or may be provided by any
                affiliates or any other third party, including in relation to
                any inaccuracies or omissions in this website; and
              </li>
              <li>
                excludes all liability for damages arising out of or in
                connection with your use of this website. This includes, without
                limitation, direct loss, loss of business or profits (whether or
                not the loss of such profits was foreseeable, arose in the
                normal course of things or damage caused to your computer,
                computer software, systems and programs and the data thereon or
                any other direct or indirect, consequential and incidental
                damages.
              </li>
            </ul>
          </div>

          <div>
            <h2>Access, Modifying or Removing Information:</h2>
            <p>
              You may at any time make a written request to find out what
              personal information we maintain, what the use of that information
              was and what the status of the stored information is. You may also
              modify or remove your personal information at any time, through
              written request. If you would like to request access to review,
              update or change the information you have you have supplied in any
              way, you may do so by sending an e-mail to us. To protect your
              privacy and security, we will also take steps to verify your
              identity before granting access or making corrections.
            </p>

            <ul>
              <h3>Cookies</h3>
              <p>
                Our website uses cookies to enable us to retrieve user details
                for each visit and to improve the quality of our services to
                you. A cookie is a small text file on your computer which a
                website sends to your computer to allow the website to store
                information which uniquely identifies our users. Cookies are
                used in some areas of our website to enable its functionality
                and ease of use for people visiting.
              </p>
              <p>
                Cookies do not collect or store personally identifiable
                information. Rather, the cookie stores a token which uniquely
                identifies a particular user at a particular time. That token is
                then linked to the user information in our secured databases.
                You can always delete the cookies and reset your browser to
                refuse all cookies or to display a message when a cookie is
                being sent. If you reset your browser, some of the website
                features and functionality may not be available to you and you
                may not be able to take advantage of all the features on the
                website.
              </p>
            </ul>

            <ul>
              <h3>Force Majeure</h3>
              <p>
                Neither party shall be liable to the other for any failure to
                perform any obligation under any Agreement which is due to an
                event beyond the control of such party including but not limited
                to any Act of God, terrorism, war, Political insurgence,
                insurrection, riot, civil unrest, act of civil or military
                authority, uprising, earthquake, flood or any other natural or
                manmade eventuality outside of our control, which causes the
                termination of an agreement or contract entered into, nor which
                could have been reasonably foreseen. Any Party affected by such
                event shall forthwith inform the other Party of the same and
                shall use all reasonable endeavors to comply with the terms and
                conditions of any Agreement contained herein.
              </p>
            </ul>

            <ul>
              <h3>Waiver</h3>
              <p>
                Failure of either Party to insist upon strict performance or
                enforcement of any provision set out in this or any Agreement or
                the failure of either Party to exercise any right or remedy to
                which it, he or they are entitled hereunder shall not be
                construed as waiver of such provisions and shall not affect the
                validity of these of these terms or constitute a waiver thereof
                and it shall not cause a diminution of the obligations under
                these terms. No waiver of any of these provisions shall be
                effective unless it is expressly stated to be such and signed by
                both Parties.
              </p>
            </ul>

            <ul>
              <h3>General</h3>
              <p>
                The laws of the Federal Republic of Nigeria govern these terms
                and conditions. By accessing this website you consent to these
                terms and conditions and to the exclusive jurisdiction of the
                federal and state courts in all disputes arising out of such
                access. If any of these terms are deemed invalid or
                unenforceable for any reason (including, but not limited to the
                exclusions and limitations set out above), then the invalid or
                unenforceable provision will be severed from these terms and the
                remaining terms will continue to apply.
              </p>
            </ul>
          </div>

          <div>
            <h2>Notification of Changes</h2>
            <p>
              We reserve the right to change these conditions from time to time
              as it sees fit and your continued use of our website will signify
              your acceptance of any adjustment to these terms. You are
              therefore advised to re-read this statement on a regular basis. We
              reserve the right to terminate your newsletter signup if we learn
              that you have provided false or misleading registration
              information.
            </p>
            <ul>
              <h3>Custody and disposal</h3>
              <p>
                We will maintain appropriate safeguards and security measures to
                protect your personal information in our custody and dispose of
                this information in an appropriate and secure manner when no
                longer required.
              </p>
              <p>
                We have numerous physical and digital security safeguards which
                reflect industry best-practices to protect the personal
                information of clients in our custody against loss, theft,
                unauthorized access, disclosure, copying, use or modification.
              </p>
            </ul>

            <ul>
              <h3>Contact Information</h3>
              <p>
                If you have questions about this Policy, or concerns or
                complaints regarding our website services please contact:
                webmaster@tenonlogistics.com
              </p>
              <p>
                Your accessing of this website and/or using our Services
                indicates your understanding, agreement to and acceptance, of
                the full Terms and Conditions contained herein.
              </p>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
